import { tThread } from "tmt_api/src/types/types";

export const includesIn = <T extends unknown>(data: T, term: string): boolean => {
  if (!term) return false;
  let includes = false;
  let key: keyof T;
  for (key in data) {
    includes = `${data[key]}`.toLowerCase().includes(term.toLocaleLowerCase());
    if (includes) break;
  }
  return includes;
};

export const useSearchHook = (
  myTableData: Array<Array<string | number>>,
  myTableRef: React.MutableRefObject<(string | number)[][]>,
  myCurrSearch: string | undefined,
): void => {
  if (myCurrSearch) {
    const aNewTableData: (string | number)[][] = [];
    Object.values(myTableData).forEach((myOrder) => {
      if (
        myOrder
          .map((myOrderPiece) => {
            return myOrderPiece.toString().toLowerCase().includes(myCurrSearch);
          })
          .reduce((previousValue: boolean, currentValue: boolean) => previousValue || currentValue)
      ) {
        aNewTableData.push(myOrder);
      }
    });
    myTableRef.current = aNewTableData;
  } else {
    myTableRef.current = myTableData;
  }
};

export const useMessageSearchHook = (
  myMessageThreads: Array<tThread>,
  myMessageRef: React.MutableRefObject<Array<tThread>>,
  myCurrSearch: string | undefined,
): void => {
  if (myCurrSearch) {
    const aNewTableData: Array<tThread> = [];
    myMessageThreads.forEach((myMessageThread) => {
      if (myMessageThread.recipientStr.includes(myCurrSearch)) {
        aNewTableData.push(myMessageThread);
      }
    });
    myMessageRef.current = aNewTableData;
  } else {
    myMessageRef.current = myMessageThreads;
  }
};

// TODO: This is broken.
export const saveRecentSearch = (
  myCurrentSearch: string,
  myRecentSearches: Array<string> | undefined,
): Array<string> | undefined => {
  if (myCurrentSearch === "" || myCurrentSearch === undefined) {
    return myRecentSearches;
  }
  if (myRecentSearches === undefined) {
    return [myCurrentSearch];
  }
  let newRecentSearches = myRecentSearches.reverse();
  if (myRecentSearches?.includes(myCurrentSearch)) {
    newRecentSearches = newRecentSearches.filter((recentSearch) => recentSearch !== myCurrentSearch);
    newRecentSearches.push(myCurrentSearch);
    return newRecentSearches.reverse();
  } else if ((myRecentSearches?.length ?? 0) >= 5) {
    newRecentSearches.shift();
    return newRecentSearches.concat([myCurrentSearch]).reverse();
  }
  return newRecentSearches.concat([myCurrentSearch]).reverse();
};
